import { FC } from 'react'

import { NodeViewProps } from '@tiptap/react'

import { useFirstRenderContext } from '../../../common/ssr/FirstRenderProvider.js'
import { ReactPlayer } from '../../../utils/react-player.js'
import { Container } from '../Container.js'
import { getVideoSizeClassName } from './utils.js'

export const Video: FC<NodeViewProps> = props => {
  const { isFirstRender } = useFirstRenderContext()
  const { src, type, size } = props.node.attrs
  // When src is undefined, the media has not been uploaded correctly
  // We need to provide a src to ReactPlayer to show the player so that the user can remove the media using the composer
  const mediaSrc = src || ' '
  const isAudio = type?.includes('audio')
  const videoSizeClassName = getVideoSizeClassName(size)

  return (
    /**
     * ReactPlayer does not allow configuring the inner audio
     * element height, as in setting height to 'revert' on the wrapper
     * will still make the audio/video element to be of size 100%
     * and no other option will force the element assume its natural height.
     * That's why the following className is added to the container with important specificity.
     */
    <Container
      className="[&_audio]:!h-[revert] rounded-base screen-rounded-none overflow-hidden"
      {...props}
    >
      {!isFirstRender && (
        <ReactPlayer
          url={mediaSrc}
          controls
          width="100%"
          height={isAudio ? 'revert' : '100%'}
          config={{
            file: { forceAudio: isAudio },
          }}
          wrapper={({ children }) => (
            <div className={videoSizeClassName}>{children}</div>
          )}
        />
      )}
    </Container>
  )
}
